import React from "react";
import { useContext } from "react";
import { I18nReactContext } from "../../../../../contexts/I18nContext";
import { get } from "lodash";
import { InstructionModal } from "../../../Shared/InstructionModal/InstructionModal";

export const QuestionnaireInstructionModal = ({ 
    open, 
    sessionQuestions, 
    questionnaireSession, 
    questionsLoaded, 
    onStartExam 
}) => {
    const { i18n } = useContext(I18nReactContext);

    return (
        <InstructionModal
            open={open}
            title={i18n.translate('questionnaireInstruction.title')}
            footerText={i18n.translate('questionnaireInstruction.goodLuck')}
            buttonText={i18n.translate('questionnaireInstruction.startButton')}
            onButtonClick={onStartExam}
            buttonDisabled={!questionsLoaded}
            loading={!questionsLoaded}
        >
            <ul className="instruction-list">
                <li>{i18n.translate('questionnaireInstruction.info1', {context: {numberOfQuestions: get(sessionQuestions, 'length', 0)}})}</li>
                <li>{i18n.translate('questionnaireInstruction.info2', {context: {passGrade: get(questionnaireSession, ['questionnaireSession','passGrade'], 0)}})}</li>
                <li>{i18n.translate('questionnaireInstruction.info3')}</li>
            </ul>
            <br/>
            <div style={{fontSize: '20px'}}>
                <strong>{i18n.translate('questionnaireInstruction.successInfo')}</strong>
                {i18n.translate('questionnaireInstruction.info4')}
                <strong>{i18n.translate('questionnaireInstruction.failInfo')}</strong>
                {i18n.translate('questionnaireInstruction.info5')}
            </div>
        </InstructionModal>
    );
} 